// components/Hero/FeaturePill.tsx
import React from "react";

interface FeaturePillProps {
  text: string;
}

export const FeaturePill: React.FC<FeaturePillProps> = ({ text }) => (
  <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#C8A96E]/20 bg-[#C8A96E]/5 hover:bg-[#C8A96E]/10 hover:border-[#C8A96E]/50 transition-all cursor-default backdrop-blur-sm group">
    <div className="w-1.5 h-1.5 rounded-full bg-[#C8A96E]/70 group-hover:scale-125 transition-transform" />
    <span className="text-[12px] uppercase tracking-widest text-[#EDE5D6]/70 group-hover:text-[#EDE5D6] font-medium transition-colors font-cairo">
      {text}
    </span>
  </div>
);
